// utils/permissionUtils.js
import { MODULES } from "../Constants/appConstants";
import { PERMISSIONS } from "../Constants/storageConstant";
import {
  getLocalData,
  getModuleOptions,
  isAdmin,
  isCounsellor,
  isDoctor,
  isDoctorAssistant,
  isHospitalAdmin,
  isManager,
  isPharmacist,
  isReceptionist,
  isStaff,
  isSuperAdmin,
  isTherapist,
} from "../Services/common";
import logger from "./logger";

const {
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  REPORTS_MODULE,
  SERVICIES_MODULE,
  ATTENDANCE_MODULE,
  VIEW_EXPANSE,
  VIEW_IPD,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  TRACK_REPORT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  CANCEL_BILL_MODULE,
  PATIENT_FOLDER,
  FINGERPRINT,
  TELECONSULT,
  VIEW_INVENTORY,
} = MODULES;

const THERAPIST_PERMISSION = [DASHBOARD_MODULE];
const STAFF_PERMISSION = [DASHBOARD_MODULE];
const ADMIN_PERMISSION = [
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  REPORTS_MODULE,
  SERVICIES_MODULE,
  ATTENDANCE_MODULE,
  VIEW_EXPANSE,
  VIEW_IPD,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  TELECONSULT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  TRACK_REPORT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  CANCEL_BILL_MODULE,
  PATIENT_FOLDER,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  FINGERPRINT,
  VIEW_INVENTORY,
];
const HOSPITAL_ADMIN_PERMISSION = [
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  REPORTS_MODULE,
  SERVICIES_MODULE,
  ATTENDANCE_MODULE,
  VIEW_EXPANSE,
  VIEW_IPD,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  TELECONSULT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  TRACK_REPORT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  CANCEL_BILL_MODULE,
  PATIENT_FOLDER,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  FINGERPRINT,
  VIEW_INVENTORY,
];
const MANAGER_PERMISSION = [
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  REPORTS_MODULE,
  SERVICIES_MODULE,
  ATTENDANCE_MODULE,
  VIEW_EXPANSE,
  VIEW_IPD,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  TELECONSULT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  TRACK_REPORT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  CANCEL_BILL_MODULE,
  PATIENT_FOLDER,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  FINGERPRINT,
  VIEW_INVENTORY,
];
const DOCTOR_PERMISSION = [
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  REPORTS_MODULE,
  SERVICIES_MODULE,
  ATTENDANCE_MODULE,
  VIEW_IPD,
  PATIENT_VISIT_ALERT,
  TELECONSULT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  CANCEL_BILL_MODULE,
  PATIENT_FOLDER,
  FINGERPRINT,
  VIEW_INVENTORY,
];
const PHARMACIST_PERMISSION = [
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  REPORTS_MODULE,
  SERVICIES_MODULE,
  ATTENDANCE_MODULE,
  VIEW_EXPANSE,
  VIEW_IPD,
  PATIENT_VISIT_ALERT,
  TELECONSULT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  TRACK_REPORT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  CANCEL_BILL_MODULE,
  PATIENT_FOLDER,
  FINGERPRINT,
  VIEW_INVENTORY,
];
const RECEPTION_PERMISSION = [
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  REPORTS_MODULE,
  SERVICIES_MODULE,
  ATTENDANCE_MODULE,
  VIEW_EXPANSE,
  VIEW_IPD,
  PATIENT_VISIT_ALERT,
  TELECONSULT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  CANCEL_BILL_MODULE,
  PATIENT_FOLDER,
  FINGERPRINT,
  VIEW_INVENTORY,
];
const canAccessModule = (moduleName = "") => {
  if (isSuperAdmin()) {
    return true;
  }

  const permissions = getLocalData(PERMISSIONS);
  logger.info(permissions);

  if (!permissions) return false;

  var $rolePermissions = [];
  if (isTherapist()) {
    $rolePermissions = THERAPIST_PERMISSION;
  }
  if (isStaff()) {
    $rolePermissions = STAFF_PERMISSION;
  }
  if (isDoctor() || isDoctorAssistant()) {
    $rolePermissions = DOCTOR_PERMISSION;
  }

  if (isAdmin()) {
    $rolePermissions = ADMIN_PERMISSION;
  }

  if (isHospitalAdmin()) {
    $rolePermissions = HOSPITAL_ADMIN_PERMISSION;
  }

  if (isManager()) {
    $rolePermissions = MANAGER_PERMISSION;
  }

  if (isPharmacist()) {
    $rolePermissions = PHARMACIST_PERMISSION;
  }

  if (isReceptionist() || isCounsellor()) {
    $rolePermissions = RECEPTION_PERMISSION;
  }

  if (Array.isArray(moduleName)) {
    return moduleName.some((name) =>
      permissions.some((p) => `view_${name}` === p?.name && $rolePermissions.includes(name)),
    );
  } else {
    return permissions.some(
      (p) => `view_${moduleName}` === p?.name && $rolePermissions.includes(moduleName),
    );
  }
};

export default canAccessModule;
